import { PageHeader } from "@/components/kit";
import { Agenda } from "@/components/Agenda";
import { PROFILES } from "@/data/mock";

export default function OwnerAgenda() {
  const cid = PROFILES.empresaria.companyId;
  return (
    <div data-testid="owner-agenda-page">
      <PageHeader eyebrow="Agenda" title="Agenda da empresa" subtitle="Reuniões, visitas, fornecedores e lembretes da sua empresa." />
      <Agenda ownerKey={cid} birthdayCompanyIds={[cid]} />
    </div>
  );
}
